/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * AI Enablement Platform
 * Enterprise AI enablement analysis and recommendations platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AccountCreateRequest,
  AccountListResponse,
  AccountResponse,
  ArtifactResponse,
  BodyImportFileRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsImportFilePost,
  BodyImportFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost,
  ExportRequest,
  HTTPValidationError,
  MagicLinkCreateRequest,
  MagicLinkListResponse,
  MagicLinkRedeemRequest,
  MagicLinkRedeemResponse,
  MagicLinkResponse,
  PublicRevisionResponse,
  PublicWorkspaceResponse,
  RevisionImportFileResponse,
  RevisionResponse,
  RevisionSaveRequest,
  SrcApiSchemasClientOpportunityRankerWorkspaceDetailResponse,
  SrcApiSchemasClientOpportunityRankerWorkspaceListResponse,
  WorkspaceImportHtmlRequest,
  WorkspaceImportHtmlResponse,
  WorkspaceImportStructuredRequest
} from '.././models';

import { customInstance } from '../../services/api-client';




/**
 * @summary List Accounts
 */
export const listAccountsV1ClientOpportunityRankerAccountsGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<AccountListResponse>(
      {url: `/v1/client-opportunity-ranker/accounts`, method: 'GET', signal
    },
      );
    }
  



export const getListAccountsV1ClientOpportunityRankerAccountsGetQueryKey = () => {
    return [
    `/v1/client-opportunity-ranker/accounts`
    ] as const;
    }

    
export const getListAccountsV1ClientOpportunityRankerAccountsGetQueryOptions = <TData = Awaited<ReturnType<typeof listAccountsV1ClientOpportunityRankerAccountsGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccountsV1ClientOpportunityRankerAccountsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAccountsV1ClientOpportunityRankerAccountsGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAccountsV1ClientOpportunityRankerAccountsGet>>> = ({ signal }) => listAccountsV1ClientOpportunityRankerAccountsGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAccountsV1ClientOpportunityRankerAccountsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListAccountsV1ClientOpportunityRankerAccountsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listAccountsV1ClientOpportunityRankerAccountsGet>>>
export type ListAccountsV1ClientOpportunityRankerAccountsGetQueryError = unknown


export function useListAccountsV1ClientOpportunityRankerAccountsGet<TData = Awaited<ReturnType<typeof listAccountsV1ClientOpportunityRankerAccountsGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccountsV1ClientOpportunityRankerAccountsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAccountsV1ClientOpportunityRankerAccountsGet>>,
          TError,
          Awaited<ReturnType<typeof listAccountsV1ClientOpportunityRankerAccountsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListAccountsV1ClientOpportunityRankerAccountsGet<TData = Awaited<ReturnType<typeof listAccountsV1ClientOpportunityRankerAccountsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccountsV1ClientOpportunityRankerAccountsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAccountsV1ClientOpportunityRankerAccountsGet>>,
          TError,
          Awaited<ReturnType<typeof listAccountsV1ClientOpportunityRankerAccountsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListAccountsV1ClientOpportunityRankerAccountsGet<TData = Awaited<ReturnType<typeof listAccountsV1ClientOpportunityRankerAccountsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccountsV1ClientOpportunityRankerAccountsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List Accounts
 */

export function useListAccountsV1ClientOpportunityRankerAccountsGet<TData = Awaited<ReturnType<typeof listAccountsV1ClientOpportunityRankerAccountsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAccountsV1ClientOpportunityRankerAccountsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListAccountsV1ClientOpportunityRankerAccountsGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Create Account
 */
export const createAccountV1ClientOpportunityRankerAccountsPost = (
    accountCreateRequest: AccountCreateRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AccountResponse>(
      {url: `/v1/client-opportunity-ranker/accounts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: accountCreateRequest, signal
    },
      );
    }
  


export const getCreateAccountV1ClientOpportunityRankerAccountsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccountV1ClientOpportunityRankerAccountsPost>>, TError,{data: AccountCreateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAccountV1ClientOpportunityRankerAccountsPost>>, TError,{data: AccountCreateRequest}, TContext> => {

const mutationKey = ['createAccountV1ClientOpportunityRankerAccountsPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAccountV1ClientOpportunityRankerAccountsPost>>, {data: AccountCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  createAccountV1ClientOpportunityRankerAccountsPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateAccountV1ClientOpportunityRankerAccountsPostMutationResult = NonNullable<Awaited<ReturnType<typeof createAccountV1ClientOpportunityRankerAccountsPost>>>
    export type CreateAccountV1ClientOpportunityRankerAccountsPostMutationBody = AccountCreateRequest
    export type CreateAccountV1ClientOpportunityRankerAccountsPostMutationError = HTTPValidationError

    /**
 * @summary Create Account
 */
export const useCreateAccountV1ClientOpportunityRankerAccountsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccountV1ClientOpportunityRankerAccountsPost>>, TError,{data: AccountCreateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAccountV1ClientOpportunityRankerAccountsPost>>,
        TError,
        {data: AccountCreateRequest},
        TContext
      > => {

      const mutationOptions = getCreateAccountV1ClientOpportunityRankerAccountsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary List Workspaces
 */
export const listWorkspacesV1ClientOpportunityRankerWorkspacesGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<SrcApiSchemasClientOpportunityRankerWorkspaceListResponse>(
      {url: `/v1/client-opportunity-ranker/workspaces`, method: 'GET', signal
    },
      );
    }
  



export const getListWorkspacesV1ClientOpportunityRankerWorkspacesGetQueryKey = () => {
    return [
    `/v1/client-opportunity-ranker/workspaces`
    ] as const;
    }

    
export const getListWorkspacesV1ClientOpportunityRankerWorkspacesGetQueryOptions = <TData = Awaited<ReturnType<typeof listWorkspacesV1ClientOpportunityRankerWorkspacesGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkspacesV1ClientOpportunityRankerWorkspacesGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListWorkspacesV1ClientOpportunityRankerWorkspacesGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWorkspacesV1ClientOpportunityRankerWorkspacesGet>>> = ({ signal }) => listWorkspacesV1ClientOpportunityRankerWorkspacesGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWorkspacesV1ClientOpportunityRankerWorkspacesGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListWorkspacesV1ClientOpportunityRankerWorkspacesGetQueryResult = NonNullable<Awaited<ReturnType<typeof listWorkspacesV1ClientOpportunityRankerWorkspacesGet>>>
export type ListWorkspacesV1ClientOpportunityRankerWorkspacesGetQueryError = unknown


export function useListWorkspacesV1ClientOpportunityRankerWorkspacesGet<TData = Awaited<ReturnType<typeof listWorkspacesV1ClientOpportunityRankerWorkspacesGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkspacesV1ClientOpportunityRankerWorkspacesGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWorkspacesV1ClientOpportunityRankerWorkspacesGet>>,
          TError,
          Awaited<ReturnType<typeof listWorkspacesV1ClientOpportunityRankerWorkspacesGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListWorkspacesV1ClientOpportunityRankerWorkspacesGet<TData = Awaited<ReturnType<typeof listWorkspacesV1ClientOpportunityRankerWorkspacesGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkspacesV1ClientOpportunityRankerWorkspacesGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWorkspacesV1ClientOpportunityRankerWorkspacesGet>>,
          TError,
          Awaited<ReturnType<typeof listWorkspacesV1ClientOpportunityRankerWorkspacesGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListWorkspacesV1ClientOpportunityRankerWorkspacesGet<TData = Awaited<ReturnType<typeof listWorkspacesV1ClientOpportunityRankerWorkspacesGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkspacesV1ClientOpportunityRankerWorkspacesGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List Workspaces
 */

export function useListWorkspacesV1ClientOpportunityRankerWorkspacesGet<TData = Awaited<ReturnType<typeof listWorkspacesV1ClientOpportunityRankerWorkspacesGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkspacesV1ClientOpportunityRankerWorkspacesGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListWorkspacesV1ClientOpportunityRankerWorkspacesGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Import Html Workspace
 */
export const importHtmlWorkspaceV1ClientOpportunityRankerWorkspacesImportHtmlPost = (
    workspaceImportHtmlRequest: WorkspaceImportHtmlRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<WorkspaceImportHtmlResponse>(
      {url: `/v1/client-opportunity-ranker/workspaces/import-html`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: workspaceImportHtmlRequest, signal
    },
      );
    }
  


export const getImportHtmlWorkspaceV1ClientOpportunityRankerWorkspacesImportHtmlPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importHtmlWorkspaceV1ClientOpportunityRankerWorkspacesImportHtmlPost>>, TError,{data: WorkspaceImportHtmlRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof importHtmlWorkspaceV1ClientOpportunityRankerWorkspacesImportHtmlPost>>, TError,{data: WorkspaceImportHtmlRequest}, TContext> => {

const mutationKey = ['importHtmlWorkspaceV1ClientOpportunityRankerWorkspacesImportHtmlPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importHtmlWorkspaceV1ClientOpportunityRankerWorkspacesImportHtmlPost>>, {data: WorkspaceImportHtmlRequest}> = (props) => {
          const {data} = props ?? {};

          return  importHtmlWorkspaceV1ClientOpportunityRankerWorkspacesImportHtmlPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImportHtmlWorkspaceV1ClientOpportunityRankerWorkspacesImportHtmlPostMutationResult = NonNullable<Awaited<ReturnType<typeof importHtmlWorkspaceV1ClientOpportunityRankerWorkspacesImportHtmlPost>>>
    export type ImportHtmlWorkspaceV1ClientOpportunityRankerWorkspacesImportHtmlPostMutationBody = WorkspaceImportHtmlRequest
    export type ImportHtmlWorkspaceV1ClientOpportunityRankerWorkspacesImportHtmlPostMutationError = HTTPValidationError

    /**
 * @summary Import Html Workspace
 */
export const useImportHtmlWorkspaceV1ClientOpportunityRankerWorkspacesImportHtmlPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importHtmlWorkspaceV1ClientOpportunityRankerWorkspacesImportHtmlPost>>, TError,{data: WorkspaceImportHtmlRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importHtmlWorkspaceV1ClientOpportunityRankerWorkspacesImportHtmlPost>>,
        TError,
        {data: WorkspaceImportHtmlRequest},
        TContext
      > => {

      const mutationOptions = getImportHtmlWorkspaceV1ClientOpportunityRankerWorkspacesImportHtmlPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Import Structured Workspace
 */
export const importStructuredWorkspaceV1ClientOpportunityRankerWorkspacesImportStructuredPost = (
    workspaceImportStructuredRequest: WorkspaceImportStructuredRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<WorkspaceImportHtmlResponse>(
      {url: `/v1/client-opportunity-ranker/workspaces/import-structured`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: workspaceImportStructuredRequest, signal
    },
      );
    }
  


export const getImportStructuredWorkspaceV1ClientOpportunityRankerWorkspacesImportStructuredPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importStructuredWorkspaceV1ClientOpportunityRankerWorkspacesImportStructuredPost>>, TError,{data: WorkspaceImportStructuredRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof importStructuredWorkspaceV1ClientOpportunityRankerWorkspacesImportStructuredPost>>, TError,{data: WorkspaceImportStructuredRequest}, TContext> => {

const mutationKey = ['importStructuredWorkspaceV1ClientOpportunityRankerWorkspacesImportStructuredPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importStructuredWorkspaceV1ClientOpportunityRankerWorkspacesImportStructuredPost>>, {data: WorkspaceImportStructuredRequest}> = (props) => {
          const {data} = props ?? {};

          return  importStructuredWorkspaceV1ClientOpportunityRankerWorkspacesImportStructuredPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImportStructuredWorkspaceV1ClientOpportunityRankerWorkspacesImportStructuredPostMutationResult = NonNullable<Awaited<ReturnType<typeof importStructuredWorkspaceV1ClientOpportunityRankerWorkspacesImportStructuredPost>>>
    export type ImportStructuredWorkspaceV1ClientOpportunityRankerWorkspacesImportStructuredPostMutationBody = WorkspaceImportStructuredRequest
    export type ImportStructuredWorkspaceV1ClientOpportunityRankerWorkspacesImportStructuredPostMutationError = HTTPValidationError

    /**
 * @summary Import Structured Workspace
 */
export const useImportStructuredWorkspaceV1ClientOpportunityRankerWorkspacesImportStructuredPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importStructuredWorkspaceV1ClientOpportunityRankerWorkspacesImportStructuredPost>>, TError,{data: WorkspaceImportStructuredRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importStructuredWorkspaceV1ClientOpportunityRankerWorkspacesImportStructuredPost>>,
        TError,
        {data: WorkspaceImportStructuredRequest},
        TContext
      > => {

      const mutationOptions = getImportStructuredWorkspaceV1ClientOpportunityRankerWorkspacesImportStructuredPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Import File Workspace
 */
export const importFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost = (
    bodyImportFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost: BodyImportFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append(`file`, bodyImportFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost.file)
formData.append(`account_name`, bodyImportFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost.account_name)
if(bodyImportFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost.account_slug !== undefined && bodyImportFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost.account_slug !== null) {
 formData.append(`account_slug`, bodyImportFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost.account_slug)
 }
if(bodyImportFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost.parent_account_id !== undefined && bodyImportFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost.parent_account_id !== null) {
 formData.append(`parent_account_id`, bodyImportFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost.parent_account_id.toString())
 }
if(bodyImportFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost.parent_account_name !== undefined && bodyImportFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost.parent_account_name !== null) {
 formData.append(`parent_account_name`, bodyImportFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost.parent_account_name)
 }
if(bodyImportFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost.workspace_title !== undefined && bodyImportFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost.workspace_title !== null) {
 formData.append(`workspace_title`, bodyImportFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost.workspace_title)
 }
if(bodyImportFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost.workspace_slug !== undefined && bodyImportFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost.workspace_slug !== null) {
 formData.append(`workspace_slug`, bodyImportFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost.workspace_slug)
 }
if(bodyImportFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost.industry !== undefined && bodyImportFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost.industry !== null) {
 formData.append(`industry`, bodyImportFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost.industry)
 }

      return customInstance<WorkspaceImportHtmlResponse>(
      {url: `/v1/client-opportunity-ranker/workspaces/import-file`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getImportFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost>>, TError,{data: BodyImportFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof importFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost>>, TError,{data: BodyImportFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost}, TContext> => {

const mutationKey = ['importFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost>>, {data: BodyImportFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost}> = (props) => {
          const {data} = props ?? {};

          return  importFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImportFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePostMutationResult = NonNullable<Awaited<ReturnType<typeof importFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost>>>
    export type ImportFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePostMutationBody = BodyImportFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost
    export type ImportFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePostMutationError = HTTPValidationError

    /**
 * @summary Import File Workspace
 */
export const useImportFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost>>, TError,{data: BodyImportFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost>>,
        TError,
        {data: BodyImportFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePost},
        TContext
      > => {

      const mutationOptions = getImportFileWorkspaceV1ClientOpportunityRankerWorkspacesImportFilePostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get Workspace
 */
export const getWorkspaceV1ClientOpportunityRankerWorkspacesWorkspaceIdGet = (
    workspaceId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SrcApiSchemasClientOpportunityRankerWorkspaceDetailResponse>(
      {url: `/v1/client-opportunity-ranker/workspaces/${workspaceId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetWorkspaceV1ClientOpportunityRankerWorkspacesWorkspaceIdGetQueryKey = (workspaceId?: number,) => {
    return [
    `/v1/client-opportunity-ranker/workspaces/${workspaceId}`
    ] as const;
    }

    
export const getGetWorkspaceV1ClientOpportunityRankerWorkspacesWorkspaceIdGetQueryOptions = <TData = Awaited<ReturnType<typeof getWorkspaceV1ClientOpportunityRankerWorkspacesWorkspaceIdGet>>, TError = HTTPValidationError>(workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceV1ClientOpportunityRankerWorkspacesWorkspaceIdGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkspaceV1ClientOpportunityRankerWorkspacesWorkspaceIdGetQueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkspaceV1ClientOpportunityRankerWorkspacesWorkspaceIdGet>>> = ({ signal }) => getWorkspaceV1ClientOpportunityRankerWorkspacesWorkspaceIdGet(workspaceId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceV1ClientOpportunityRankerWorkspacesWorkspaceIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetWorkspaceV1ClientOpportunityRankerWorkspacesWorkspaceIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkspaceV1ClientOpportunityRankerWorkspacesWorkspaceIdGet>>>
export type GetWorkspaceV1ClientOpportunityRankerWorkspacesWorkspaceIdGetQueryError = HTTPValidationError


export function useGetWorkspaceV1ClientOpportunityRankerWorkspacesWorkspaceIdGet<TData = Awaited<ReturnType<typeof getWorkspaceV1ClientOpportunityRankerWorkspacesWorkspaceIdGet>>, TError = HTTPValidationError>(
 workspaceId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceV1ClientOpportunityRankerWorkspacesWorkspaceIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkspaceV1ClientOpportunityRankerWorkspacesWorkspaceIdGet>>,
          TError,
          Awaited<ReturnType<typeof getWorkspaceV1ClientOpportunityRankerWorkspacesWorkspaceIdGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWorkspaceV1ClientOpportunityRankerWorkspacesWorkspaceIdGet<TData = Awaited<ReturnType<typeof getWorkspaceV1ClientOpportunityRankerWorkspacesWorkspaceIdGet>>, TError = HTTPValidationError>(
 workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceV1ClientOpportunityRankerWorkspacesWorkspaceIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkspaceV1ClientOpportunityRankerWorkspacesWorkspaceIdGet>>,
          TError,
          Awaited<ReturnType<typeof getWorkspaceV1ClientOpportunityRankerWorkspacesWorkspaceIdGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWorkspaceV1ClientOpportunityRankerWorkspacesWorkspaceIdGet<TData = Awaited<ReturnType<typeof getWorkspaceV1ClientOpportunityRankerWorkspacesWorkspaceIdGet>>, TError = HTTPValidationError>(
 workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceV1ClientOpportunityRankerWorkspacesWorkspaceIdGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Workspace
 */

export function useGetWorkspaceV1ClientOpportunityRankerWorkspacesWorkspaceIdGet<TData = Awaited<ReturnType<typeof getWorkspaceV1ClientOpportunityRankerWorkspacesWorkspaceIdGet>>, TError = HTTPValidationError>(
 workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceV1ClientOpportunityRankerWorkspacesWorkspaceIdGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetWorkspaceV1ClientOpportunityRankerWorkspacesWorkspaceIdGetQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Save Revision
 */
export const saveRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsPost = (
    workspaceId: number,
    revisionSaveRequest: RevisionSaveRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<RevisionResponse>(
      {url: `/v1/client-opportunity-ranker/workspaces/${workspaceId}/revisions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: revisionSaveRequest, signal
    },
      );
    }
  


export const getSaveRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsPost>>, TError,{workspaceId: number;data: RevisionSaveRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof saveRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsPost>>, TError,{workspaceId: number;data: RevisionSaveRequest}, TContext> => {

const mutationKey = ['saveRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsPost>>, {workspaceId: number;data: RevisionSaveRequest}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  saveRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsPost(workspaceId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SaveRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsPostMutationResult = NonNullable<Awaited<ReturnType<typeof saveRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsPost>>>
    export type SaveRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsPostMutationBody = RevisionSaveRequest
    export type SaveRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsPostMutationError = HTTPValidationError

    /**
 * @summary Save Revision
 */
export const useSaveRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsPost>>, TError,{workspaceId: number;data: RevisionSaveRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsPost>>,
        TError,
        {workspaceId: number;data: RevisionSaveRequest},
        TContext
      > => {

      const mutationOptions = getSaveRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Import File Revision
 */
export const importFileRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsImportFilePost = (
    workspaceId: number,
    bodyImportFileRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsImportFilePost: BodyImportFileRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsImportFilePost,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append(`file`, bodyImportFileRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsImportFilePost.file)
formData.append(`base_revision_number`, bodyImportFileRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsImportFilePost.base_revision_number.toString())
if(bodyImportFileRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsImportFilePost.notes !== undefined && bodyImportFileRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsImportFilePost.notes !== null) {
 formData.append(`notes`, bodyImportFileRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsImportFilePost.notes)
 }

      return customInstance<RevisionImportFileResponse>(
      {url: `/v1/client-opportunity-ranker/workspaces/${workspaceId}/revisions/import-file`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getImportFileRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsImportFilePostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importFileRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsImportFilePost>>, TError,{workspaceId: number;data: BodyImportFileRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsImportFilePost}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof importFileRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsImportFilePost>>, TError,{workspaceId: number;data: BodyImportFileRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsImportFilePost}, TContext> => {

const mutationKey = ['importFileRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsImportFilePost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importFileRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsImportFilePost>>, {workspaceId: number;data: BodyImportFileRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsImportFilePost}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  importFileRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsImportFilePost(workspaceId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImportFileRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsImportFilePostMutationResult = NonNullable<Awaited<ReturnType<typeof importFileRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsImportFilePost>>>
    export type ImportFileRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsImportFilePostMutationBody = BodyImportFileRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsImportFilePost
    export type ImportFileRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsImportFilePostMutationError = HTTPValidationError

    /**
 * @summary Import File Revision
 */
export const useImportFileRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsImportFilePost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importFileRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsImportFilePost>>, TError,{workspaceId: number;data: BodyImportFileRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsImportFilePost}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importFileRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsImportFilePost>>,
        TError,
        {workspaceId: number;data: BodyImportFileRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsImportFilePost},
        TContext
      > => {

      const mutationOptions = getImportFileRevisionV1ClientOpportunityRankerWorkspacesWorkspaceIdRevisionsImportFilePostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Create Export
 */
export const createExportV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsPost = (
    workspaceId: number,
    exportRequest: ExportRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ArtifactResponse>(
      {url: `/v1/client-opportunity-ranker/workspaces/${workspaceId}/exports`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: exportRequest, signal
    },
      );
    }
  


export const getCreateExportV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createExportV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsPost>>, TError,{workspaceId: number;data: ExportRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createExportV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsPost>>, TError,{workspaceId: number;data: ExportRequest}, TContext> => {

const mutationKey = ['createExportV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createExportV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsPost>>, {workspaceId: number;data: ExportRequest}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  createExportV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsPost(workspaceId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateExportV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsPostMutationResult = NonNullable<Awaited<ReturnType<typeof createExportV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsPost>>>
    export type CreateExportV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsPostMutationBody = ExportRequest
    export type CreateExportV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsPostMutationError = HTTPValidationError

    /**
 * @summary Create Export
 */
export const useCreateExportV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createExportV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsPost>>, TError,{workspaceId: number;data: ExportRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createExportV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsPost>>,
        TError,
        {workspaceId: number;data: ExportRequest},
        TContext
      > => {

      const mutationOptions = getCreateExportV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Download Export Artifact
 */
export const downloadExportArtifactV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsArtifactIdDownloadGet = (
    workspaceId: number,
    artifactId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/v1/client-opportunity-ranker/workspaces/${workspaceId}/exports/${artifactId}/download`, method: 'GET', signal
    },
      );
    }
  



export const getDownloadExportArtifactV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsArtifactIdDownloadGetQueryKey = (workspaceId?: number,
    artifactId?: number,) => {
    return [
    `/v1/client-opportunity-ranker/workspaces/${workspaceId}/exports/${artifactId}/download`
    ] as const;
    }

    
export const getDownloadExportArtifactV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsArtifactIdDownloadGetQueryOptions = <TData = Awaited<ReturnType<typeof downloadExportArtifactV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsArtifactIdDownloadGet>>, TError = HTTPValidationError>(workspaceId: number,
    artifactId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadExportArtifactV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsArtifactIdDownloadGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadExportArtifactV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsArtifactIdDownloadGetQueryKey(workspaceId,artifactId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadExportArtifactV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsArtifactIdDownloadGet>>> = ({ signal }) => downloadExportArtifactV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsArtifactIdDownloadGet(workspaceId,artifactId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId && artifactId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadExportArtifactV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsArtifactIdDownloadGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type DownloadExportArtifactV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsArtifactIdDownloadGetQueryResult = NonNullable<Awaited<ReturnType<typeof downloadExportArtifactV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsArtifactIdDownloadGet>>>
export type DownloadExportArtifactV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsArtifactIdDownloadGetQueryError = HTTPValidationError


export function useDownloadExportArtifactV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsArtifactIdDownloadGet<TData = Awaited<ReturnType<typeof downloadExportArtifactV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsArtifactIdDownloadGet>>, TError = HTTPValidationError>(
 workspaceId: number,
    artifactId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadExportArtifactV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsArtifactIdDownloadGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadExportArtifactV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsArtifactIdDownloadGet>>,
          TError,
          Awaited<ReturnType<typeof downloadExportArtifactV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsArtifactIdDownloadGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDownloadExportArtifactV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsArtifactIdDownloadGet<TData = Awaited<ReturnType<typeof downloadExportArtifactV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsArtifactIdDownloadGet>>, TError = HTTPValidationError>(
 workspaceId: number,
    artifactId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadExportArtifactV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsArtifactIdDownloadGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadExportArtifactV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsArtifactIdDownloadGet>>,
          TError,
          Awaited<ReturnType<typeof downloadExportArtifactV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsArtifactIdDownloadGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDownloadExportArtifactV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsArtifactIdDownloadGet<TData = Awaited<ReturnType<typeof downloadExportArtifactV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsArtifactIdDownloadGet>>, TError = HTTPValidationError>(
 workspaceId: number,
    artifactId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadExportArtifactV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsArtifactIdDownloadGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Download Export Artifact
 */

export function useDownloadExportArtifactV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsArtifactIdDownloadGet<TData = Awaited<ReturnType<typeof downloadExportArtifactV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsArtifactIdDownloadGet>>, TError = HTTPValidationError>(
 workspaceId: number,
    artifactId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadExportArtifactV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsArtifactIdDownloadGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getDownloadExportArtifactV1ClientOpportunityRankerWorkspacesWorkspaceIdExportsArtifactIdDownloadGetQueryOptions(workspaceId,artifactId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary List Magic Links
 */
export const listMagicLinksV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksGet = (
    workspaceId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<MagicLinkListResponse>(
      {url: `/v1/client-opportunity-ranker/workspaces/${workspaceId}/access-links`, method: 'GET', signal
    },
      );
    }
  



export const getListMagicLinksV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksGetQueryKey = (workspaceId?: number,) => {
    return [
    `/v1/client-opportunity-ranker/workspaces/${workspaceId}/access-links`
    ] as const;
    }

    
export const getListMagicLinksV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksGetQueryOptions = <TData = Awaited<ReturnType<typeof listMagicLinksV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksGet>>, TError = HTTPValidationError>(workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMagicLinksV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMagicLinksV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksGetQueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMagicLinksV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksGet>>> = ({ signal }) => listMagicLinksV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksGet(workspaceId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMagicLinksV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListMagicLinksV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksGetQueryResult = NonNullable<Awaited<ReturnType<typeof listMagicLinksV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksGet>>>
export type ListMagicLinksV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksGetQueryError = HTTPValidationError


export function useListMagicLinksV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksGet<TData = Awaited<ReturnType<typeof listMagicLinksV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksGet>>, TError = HTTPValidationError>(
 workspaceId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMagicLinksV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMagicLinksV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksGet>>,
          TError,
          Awaited<ReturnType<typeof listMagicLinksV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListMagicLinksV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksGet<TData = Awaited<ReturnType<typeof listMagicLinksV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksGet>>, TError = HTTPValidationError>(
 workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMagicLinksV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMagicLinksV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksGet>>,
          TError,
          Awaited<ReturnType<typeof listMagicLinksV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListMagicLinksV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksGet<TData = Awaited<ReturnType<typeof listMagicLinksV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksGet>>, TError = HTTPValidationError>(
 workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMagicLinksV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List Magic Links
 */

export function useListMagicLinksV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksGet<TData = Awaited<ReturnType<typeof listMagicLinksV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksGet>>, TError = HTTPValidationError>(
 workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMagicLinksV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListMagicLinksV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksGetQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Create Magic Link
 */
export const createMagicLinkV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksPost = (
    workspaceId: number,
    magicLinkCreateRequest: MagicLinkCreateRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<MagicLinkResponse>(
      {url: `/v1/client-opportunity-ranker/workspaces/${workspaceId}/access-links`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: magicLinkCreateRequest, signal
    },
      );
    }
  


export const getCreateMagicLinkV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMagicLinkV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksPost>>, TError,{workspaceId: number;data: MagicLinkCreateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createMagicLinkV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksPost>>, TError,{workspaceId: number;data: MagicLinkCreateRequest}, TContext> => {

const mutationKey = ['createMagicLinkV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMagicLinkV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksPost>>, {workspaceId: number;data: MagicLinkCreateRequest}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  createMagicLinkV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksPost(workspaceId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateMagicLinkV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksPostMutationResult = NonNullable<Awaited<ReturnType<typeof createMagicLinkV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksPost>>>
    export type CreateMagicLinkV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksPostMutationBody = MagicLinkCreateRequest
    export type CreateMagicLinkV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksPostMutationError = HTTPValidationError

    /**
 * @summary Create Magic Link
 */
export const useCreateMagicLinkV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMagicLinkV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksPost>>, TError,{workspaceId: number;data: MagicLinkCreateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createMagicLinkV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksPost>>,
        TError,
        {workspaceId: number;data: MagicLinkCreateRequest},
        TContext
      > => {

      const mutationOptions = getCreateMagicLinkV1ClientOpportunityRankerWorkspacesWorkspaceIdAccessLinksPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Revoke Magic Link
 */
export const revokeMagicLinkV1ClientOpportunityRankerAccessLinksLinkIdRevokePost = (
    linkId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<MagicLinkResponse>(
      {url: `/v1/client-opportunity-ranker/access-links/${linkId}/revoke`, method: 'POST', signal
    },
      );
    }
  


export const getRevokeMagicLinkV1ClientOpportunityRankerAccessLinksLinkIdRevokePostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeMagicLinkV1ClientOpportunityRankerAccessLinksLinkIdRevokePost>>, TError,{linkId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof revokeMagicLinkV1ClientOpportunityRankerAccessLinksLinkIdRevokePost>>, TError,{linkId: number}, TContext> => {

const mutationKey = ['revokeMagicLinkV1ClientOpportunityRankerAccessLinksLinkIdRevokePost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeMagicLinkV1ClientOpportunityRankerAccessLinksLinkIdRevokePost>>, {linkId: number}> = (props) => {
          const {linkId} = props ?? {};

          return  revokeMagicLinkV1ClientOpportunityRankerAccessLinksLinkIdRevokePost(linkId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RevokeMagicLinkV1ClientOpportunityRankerAccessLinksLinkIdRevokePostMutationResult = NonNullable<Awaited<ReturnType<typeof revokeMagicLinkV1ClientOpportunityRankerAccessLinksLinkIdRevokePost>>>
    
    export type RevokeMagicLinkV1ClientOpportunityRankerAccessLinksLinkIdRevokePostMutationError = HTTPValidationError

    /**
 * @summary Revoke Magic Link
 */
export const useRevokeMagicLinkV1ClientOpportunityRankerAccessLinksLinkIdRevokePost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeMagicLinkV1ClientOpportunityRankerAccessLinksLinkIdRevokePost>>, TError,{linkId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof revokeMagicLinkV1ClientOpportunityRankerAccessLinksLinkIdRevokePost>>,
        TError,
        {linkId: number},
        TContext
      > => {

      const mutationOptions = getRevokeMagicLinkV1ClientOpportunityRankerAccessLinksLinkIdRevokePostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Redeem Public Magic Link
 */
export const redeemPublicMagicLinkV1ClientOpportunityRankerPublicShareTokenRedeemPost = (
    token: string,
    magicLinkRedeemRequest: MagicLinkRedeemRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<MagicLinkRedeemResponse>(
      {url: `/v1/client-opportunity-ranker/public/share/${token}/redeem`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: magicLinkRedeemRequest, signal
    },
      );
    }
  


export const getRedeemPublicMagicLinkV1ClientOpportunityRankerPublicShareTokenRedeemPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redeemPublicMagicLinkV1ClientOpportunityRankerPublicShareTokenRedeemPost>>, TError,{token: string;data: MagicLinkRedeemRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof redeemPublicMagicLinkV1ClientOpportunityRankerPublicShareTokenRedeemPost>>, TError,{token: string;data: MagicLinkRedeemRequest}, TContext> => {

const mutationKey = ['redeemPublicMagicLinkV1ClientOpportunityRankerPublicShareTokenRedeemPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof redeemPublicMagicLinkV1ClientOpportunityRankerPublicShareTokenRedeemPost>>, {token: string;data: MagicLinkRedeemRequest}> = (props) => {
          const {token,data} = props ?? {};

          return  redeemPublicMagicLinkV1ClientOpportunityRankerPublicShareTokenRedeemPost(token,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RedeemPublicMagicLinkV1ClientOpportunityRankerPublicShareTokenRedeemPostMutationResult = NonNullable<Awaited<ReturnType<typeof redeemPublicMagicLinkV1ClientOpportunityRankerPublicShareTokenRedeemPost>>>
    export type RedeemPublicMagicLinkV1ClientOpportunityRankerPublicShareTokenRedeemPostMutationBody = MagicLinkRedeemRequest
    export type RedeemPublicMagicLinkV1ClientOpportunityRankerPublicShareTokenRedeemPostMutationError = HTTPValidationError

    /**
 * @summary Redeem Public Magic Link
 */
export const useRedeemPublicMagicLinkV1ClientOpportunityRankerPublicShareTokenRedeemPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redeemPublicMagicLinkV1ClientOpportunityRankerPublicShareTokenRedeemPost>>, TError,{token: string;data: MagicLinkRedeemRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof redeemPublicMagicLinkV1ClientOpportunityRankerPublicShareTokenRedeemPost>>,
        TError,
        {token: string;data: MagicLinkRedeemRequest},
        TContext
      > => {

      const mutationOptions = getRedeemPublicMagicLinkV1ClientOpportunityRankerPublicShareTokenRedeemPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get Public Workspace
 */
export const getPublicWorkspaceV1ClientOpportunityRankerPublicWorkspacesPublicTokenGet = (
    publicToken: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PublicWorkspaceResponse>(
      {url: `/v1/client-opportunity-ranker/public/workspaces/${publicToken}`, method: 'GET', signal
    },
      );
    }
  



export const getGetPublicWorkspaceV1ClientOpportunityRankerPublicWorkspacesPublicTokenGetQueryKey = (publicToken?: string,) => {
    return [
    `/v1/client-opportunity-ranker/public/workspaces/${publicToken}`
    ] as const;
    }

    
export const getGetPublicWorkspaceV1ClientOpportunityRankerPublicWorkspacesPublicTokenGetQueryOptions = <TData = Awaited<ReturnType<typeof getPublicWorkspaceV1ClientOpportunityRankerPublicWorkspacesPublicTokenGet>>, TError = HTTPValidationError>(publicToken: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicWorkspaceV1ClientOpportunityRankerPublicWorkspacesPublicTokenGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicWorkspaceV1ClientOpportunityRankerPublicWorkspacesPublicTokenGetQueryKey(publicToken);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicWorkspaceV1ClientOpportunityRankerPublicWorkspacesPublicTokenGet>>> = ({ signal }) => getPublicWorkspaceV1ClientOpportunityRankerPublicWorkspacesPublicTokenGet(publicToken, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(publicToken), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicWorkspaceV1ClientOpportunityRankerPublicWorkspacesPublicTokenGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPublicWorkspaceV1ClientOpportunityRankerPublicWorkspacesPublicTokenGetQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicWorkspaceV1ClientOpportunityRankerPublicWorkspacesPublicTokenGet>>>
export type GetPublicWorkspaceV1ClientOpportunityRankerPublicWorkspacesPublicTokenGetQueryError = HTTPValidationError


export function useGetPublicWorkspaceV1ClientOpportunityRankerPublicWorkspacesPublicTokenGet<TData = Awaited<ReturnType<typeof getPublicWorkspaceV1ClientOpportunityRankerPublicWorkspacesPublicTokenGet>>, TError = HTTPValidationError>(
 publicToken: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicWorkspaceV1ClientOpportunityRankerPublicWorkspacesPublicTokenGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicWorkspaceV1ClientOpportunityRankerPublicWorkspacesPublicTokenGet>>,
          TError,
          Awaited<ReturnType<typeof getPublicWorkspaceV1ClientOpportunityRankerPublicWorkspacesPublicTokenGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPublicWorkspaceV1ClientOpportunityRankerPublicWorkspacesPublicTokenGet<TData = Awaited<ReturnType<typeof getPublicWorkspaceV1ClientOpportunityRankerPublicWorkspacesPublicTokenGet>>, TError = HTTPValidationError>(
 publicToken: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicWorkspaceV1ClientOpportunityRankerPublicWorkspacesPublicTokenGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicWorkspaceV1ClientOpportunityRankerPublicWorkspacesPublicTokenGet>>,
          TError,
          Awaited<ReturnType<typeof getPublicWorkspaceV1ClientOpportunityRankerPublicWorkspacesPublicTokenGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPublicWorkspaceV1ClientOpportunityRankerPublicWorkspacesPublicTokenGet<TData = Awaited<ReturnType<typeof getPublicWorkspaceV1ClientOpportunityRankerPublicWorkspacesPublicTokenGet>>, TError = HTTPValidationError>(
 publicToken: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicWorkspaceV1ClientOpportunityRankerPublicWorkspacesPublicTokenGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Public Workspace
 */

export function useGetPublicWorkspaceV1ClientOpportunityRankerPublicWorkspacesPublicTokenGet<TData = Awaited<ReturnType<typeof getPublicWorkspaceV1ClientOpportunityRankerPublicWorkspacesPublicTokenGet>>, TError = HTTPValidationError>(
 publicToken: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicWorkspaceV1ClientOpportunityRankerPublicWorkspacesPublicTokenGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPublicWorkspaceV1ClientOpportunityRankerPublicWorkspacesPublicTokenGetQueryOptions(publicToken,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Save Public Revision
 */
export const savePublicRevisionV1ClientOpportunityRankerPublicWorkspacesPublicTokenRevisionsPost = (
    publicToken: string,
    revisionSaveRequest: RevisionSaveRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PublicRevisionResponse>(
      {url: `/v1/client-opportunity-ranker/public/workspaces/${publicToken}/revisions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: revisionSaveRequest, signal
    },
      );
    }
  


export const getSavePublicRevisionV1ClientOpportunityRankerPublicWorkspacesPublicTokenRevisionsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof savePublicRevisionV1ClientOpportunityRankerPublicWorkspacesPublicTokenRevisionsPost>>, TError,{publicToken: string;data: RevisionSaveRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof savePublicRevisionV1ClientOpportunityRankerPublicWorkspacesPublicTokenRevisionsPost>>, TError,{publicToken: string;data: RevisionSaveRequest}, TContext> => {

const mutationKey = ['savePublicRevisionV1ClientOpportunityRankerPublicWorkspacesPublicTokenRevisionsPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof savePublicRevisionV1ClientOpportunityRankerPublicWorkspacesPublicTokenRevisionsPost>>, {publicToken: string;data: RevisionSaveRequest}> = (props) => {
          const {publicToken,data} = props ?? {};

          return  savePublicRevisionV1ClientOpportunityRankerPublicWorkspacesPublicTokenRevisionsPost(publicToken,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SavePublicRevisionV1ClientOpportunityRankerPublicWorkspacesPublicTokenRevisionsPostMutationResult = NonNullable<Awaited<ReturnType<typeof savePublicRevisionV1ClientOpportunityRankerPublicWorkspacesPublicTokenRevisionsPost>>>
    export type SavePublicRevisionV1ClientOpportunityRankerPublicWorkspacesPublicTokenRevisionsPostMutationBody = RevisionSaveRequest
    export type SavePublicRevisionV1ClientOpportunityRankerPublicWorkspacesPublicTokenRevisionsPostMutationError = HTTPValidationError

    /**
 * @summary Save Public Revision
 */
export const useSavePublicRevisionV1ClientOpportunityRankerPublicWorkspacesPublicTokenRevisionsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof savePublicRevisionV1ClientOpportunityRankerPublicWorkspacesPublicTokenRevisionsPost>>, TError,{publicToken: string;data: RevisionSaveRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof savePublicRevisionV1ClientOpportunityRankerPublicWorkspacesPublicTokenRevisionsPost>>,
        TError,
        {publicToken: string;data: RevisionSaveRequest},
        TContext
      > => {

      const mutationOptions = getSavePublicRevisionV1ClientOpportunityRankerPublicWorkspacesPublicTokenRevisionsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    